import { Component, Inject, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';

@Component({
    selector: 'pace-docbox-tabbed-modal',
    templateUrl: './docbox-tabbed-modal.component.html',
    styleUrls: ['./docbox-tabbed-modal.component.scss'],
})
export class DocBoxTabbedModalComponent implements OnInit {
    public notificationModalTabHeaders: {
        notificationHistoryTabTitle: string;
        docBoxFreeSearchTabTitle: string;
    };

    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly modalInstance: BsModalRef,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.notificationModalTabHeaders = {
            notificationHistoryTabTitle: <string>(
                this.translate.instant('DASHBOARD_DOCBOX_TABBED_MODAL_NOTIFICATION_HISTORY_TAB_TITLE')
            ),
            docBoxFreeSearchTabTitle: <string>(
                this.translate.instant('DASHBOARD_DOCBOX_TABBED_MODAL_DOCBOX_FREE_SEARCH_TAB_TITLE')
            ),
        };
    }
}
